import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

const PLACEHOLDER_VALUES = new Set([
  undefined,
  '',
  'your_service_id_here',
  'your_template_id_here',
  'your_public_key_here',
]);

const isConfigured =
  !PLACEHOLDER_VALUES.has(SERVICE_ID) &&
  !PLACEHOLDER_VALUES.has(TEMPLATE_ID) &&
  !PLACEHOLDER_VALUES.has(PUBLIC_KEY);

export default function ContactForm() {
  const formRef = useRef(null);
  const [status, setStatus] = useState('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!isConfigured) {
      setStatus('error');
      setErrorMessage(
        'Contact form is not configured yet, please email the practice directly.'
      );
      return;
    }

    setStatus('sending');
    setErrorMessage('');

    emailjs
      .sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, {
        publicKey: PUBLIC_KEY,
      })
      .then(() => {
        setStatus('success');
        formRef.current?.reset();
      })
      .catch((err) => {
        setStatus('error');
        setErrorMessage(
          err?.text || 'Something went wrong sending your message. Please try again.'
        );
      });
  };

  const isSending = status === 'sending';

  return (
    <form
      ref={formRef}
      onSubmit={handleSubmit}
      className="cs_contact_form cs_style_1 cs_white_bg cs_radius_30"
      noValidate
    >
      <div className="row">
        <div className="col-lg-6">
          <label className="cs_input_label cs_heading_color">Name</label>
          <input
            type="text"
            name="name"
            required
            className="cs_form_field"
            placeholder="David John"
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-6">
          <label className="cs_input_label cs_heading_color">Email</label>
          <input
            type="email"
            name="email"
            required
            className="cs_form_field"
            placeholder="example@gmail.com"
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-12">
          <label className="cs_input_label cs_heading_color">Subject</label>
          <input
            type="text"
            name="subject"
            required
            className="cs_form_field"
            placeholder="Your subject"
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-12">
          <label className="cs_input_label cs_heading_color">Message</label>
          <textarea
            cols={30}
            rows={10}
            name="message"
            required
            className="cs_form_field"
            placeholder="Write something..."
            defaultValue={''}
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-12">
          <div className="cs_height_18" />
          <button
            type="submit"
            className="cs_btn cs_style_1"
            disabled={isSending}
          >
            <span>{isSending ? 'Sending…' : 'Submit'}</span>
            <i>
              <img src="/images/icons/arrow_white.svg" alt="Icon" />
              <img src="/images/icons/arrow_white.svg" alt="Icon" />
            </i>
          </button>
          {status === 'success' && (
            <p
              role="status"
              className="cs_fs_18 mt-3 mb-0"
              style={{ color: '#19a93b' }}
            >
              Thank you, your message has been sent. We'll be in touch soon.
            </p>
          )}
          {status === 'error' && (
            <p
              role="alert"
              className="cs_fs_18 mt-3 mb-0"
              style={{ color: '#d6336c' }}
            >
              {errorMessage}
            </p>
          )}
        </div>
      </div>
    </form>
  );
}
